// The trajectory is the record of a turn so far — every round's raw output plus the result
// of each tool call — replayed to the model on each new round.

/** The assistant text that rides alongside a round's tool calls — what it says it is doing. */
export const pickNarration = (outputItems) => outputItems
  .filter((item) => item.type === 'message')
  .flatMap((item) => item.content || [])
  .filter((part) => part.type === 'output_text' && part.text)
  .map((part) => part.text.trim())
  .join('\n\n')

/**
 * Records a completed round. Raw output is replayed verbatim because providers reject
 * replayed tool calls without their reasoning artifacts. Entries are never rewritten once
 * appended — an unchanged trajectory stays a stable prompt prefix, so it keeps cache hits.
 */
export const appendRoundToTrajectory = (trajectory, outputItems, calls) => {
  for (const output of outputItems) {
    trajectory.push(output)
  }

  for (const call of calls) {
    trajectory.push({
      type: 'function_call_output',
      call_id: call.item.call_id,
      output: JSON.stringify(call.result)
    })
  }
}
